import { Component, Input } from '@angular/core';
import { NotifyModel } from './notify.model';
import { RebirthNGConfig } from '../rebirth-ng.config';

@Component({
  selector: 're-notify',
  template: "\n    <re-alert-box *ngFor=\"let item of notifies\" [type]=\"item.type\" [closable]=\"true\" (close)=\"close(item)\"><div *ngIf=\"!item.template\" [innerHTML]=\"item.html\"></div><ng-template *ngIf=\"item.template\" [ngTemplateOutlet]=\"item.template\" [ngTemplateOutletContext]=\"{ $implicit: item }\"></ng-template></re-alert-box>\n  ",
  styles: ["\n    :host{display:block;width:100%;position:fixed;z-index:9999}:host.alert-top{left:0;top:0}:host.alert-top-right{width:40%;min-width:200px;right:10px;top:10px}:host.alert-bottom{left:0;bottom:0}:host.alert-bottom-right{width:40%;min-width:200px;right:10px;bottom:10px}:host.alert-center{width:40%;min-width:200px;left:30%;top:20%}:host ::ng-deep .alert{margin:0 0 5px 0}:host.alert-bottom ::ng-deep .alert,:host.alert-top ::ng-deep .alert{border-radius:0}\n  "],
  host: {
    '[style.width]': 'width',
    '[class]': '(placement ? "alert-" + placement : "") + " " + (cssClass || "")',
  }
})
export class NotifyComponent {
  @Input() notifies: NotifyModel[] = [];
  @Input() width: string;
  @Input() cssClass: string;
  @Input() placement: 'top' | 'top-right' | 'bottom' | 'bottom-right' | 'center';

  constructor(private rebirthNGConfig: RebirthNGConfig) {
    this.placement = <any>rebirthNGConfig.alertBoxPanel.placement;
    this.cssClass = rebirthNGConfig.alertBoxPanel.cssClass;
    this.width = rebirthNGConfig.alertBoxPanel.width;
  }

  close(item) {
    this.notifies = this.notifies.filter((box) => box !== item);
  }
}
